<template>
<transition v-if="d_banner"  name="slide-fade" mode="out-in">
  <section class="main-banner" :class="{'ismobile' : isMobile}">
    <div class="container position-relative d-flex">
        <!-- default banner -->
        <div :class="{'order-5' : isMobile}" id="mainBannerCarousel" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="7500" data-bs-pause="false">
            <div v-for="(item, index) in d_banner.carousel" :key="item.title" class="carousel-item" :class="{active : index == 0}">
                <div class="d-flex align-items-center banner-content">
                    <span>
                        <header class="mb-5">{{ item.title }}</header>
                        <h1 class="align-self-center" v-html="item.quote"></h1>
                        <p v-if="item.author" class="author">{{ item.author}}</p>
                        <!-- Seitenlink mit URL -->
                        <router-link v-if="linkParam" :to="linkParam" class="btn btn-outline-ito hover-red animated-arrow mt-3 d-inline-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                            </svg>
                            {{item.buttonText}}
                        </router-link>
                        <router-link v-if="!linkParam && item.buttonLink && item.buttonLink.charAt(0) !== '#'" :to="item.buttonLink" class="btn btn-outline-ito hover-red animated-arrow mt-3 d-inline-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                            </svg>
                            {{item.buttonText}}
                        </router-link>
                        <!-- Sprungmarke -->
                        <a v-if="!linkParam && item.buttonLink && item.buttonLink.charAt(0) == '#'" :href="item.buttonLink" @click="slidetoElement" class="btn btn-outline-ito hover-red animated-arrow mt-3 d-inline-flex align-items-center"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                            </svg>
                            {{item.buttonText}}
                        </a>
                    </span>
               </div>
            </div>
        </div>
    </div>
    <div id="videoContent" :class="{'order-1' : isMobile}">
        <video v-if="!isMobile && d_banner.file && d_banner.file.type === 'video/mp4'" id="videoBG" :poster="d_banner.fallback.data.full_url" autoplay muted loop playsinline autobuffer>
            <source v-if="d_banner.file" :src="d_banner.file.data.full_url" type="video/mp4">
            <source v-if="d_banner.file_ogg" :src="d_banner.file_ogg.data.full_url" type="video/ogg">
        </video>
        <img v-else id="imgBG" title="BannerBild" alt="BannerBild" :width="d_banner.fallback.width" :height="d_banner.fallback.height" class="img-fluid" :src="d_banner.fallback.data.full_url" />
    </div>
  </section>
</transition>
<section v-else class="main-banner-prev"></section>
</template>
<script>
import axios from 'axios'
import { Carousel } from 'bootstrap'

export default {
  name: 'MainBanner',
  data: function () {
    return {
      d_banner: null
    }
  },
  props: {
    banner: String,
    linkParam: String
  },
  computed: {
    isAnchorLink: function (el) {
      return (typeof el === 'string') ? el.charAt(0) === '#' : false
    },
    isMobile: function () {
      // hide videos in mobile view for better load performance
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
  },
  beforeMount () {
    this.getBannerData()
  },
  updated () {
    const bannerElement = document.querySelector('#mainBannerCarousel')
    const bootstrapBanner = new Carousel(bannerElement, {
      interval: 7500
    })
    bootstrapBanner.cycle()
  },
  methods: {
    getBannerData: function () {
      axios.get('/banner?fields=*.*&filter[title]=' + this.banner)
        .then(response => {
          this.d_banner = response.data.data.length ? response.data.data[0] : null
        })
    },
    slidetoElement: function (e) {
      e.preventDefault()
      const scrollToEl = document.querySelector(e.target.attributes.href.nodeValue) !== null
      if (scrollToEl) {
        document.querySelector(e.target.attributes.href.nodeValue).scrollIntoView({
          behavior: 'smooth'
        })
      }
    }
  },
  watch: {
    banner: function () {
      this.getBannerData()
    }
  }
}
</script>
<style>
.main-banner {min-height: 400px; position: relative; overflow: hidden;}
.main-banner-prev {min-height: 400px; height: calc(60vw * 720 / 1280); background: #ddd; display: block;}
.main-banner .carousel {width: 100%;}
.main-banner .carousel-item, .banner-content {min-height: 300px; }
.main-banner:not(.ismobile) .container .carousel-item {background: #fff;}
.main-banner .carousel-item header, p.author {color: #aaa; text-transform: uppercase; font-family: 'Work Sans', sans-serif; }
.banner-content h1 {font-size: 1.4rem; font-weight: 100; font-family: 'Merriweather', sans-serif; color: #444; font-style: italic;}

@media(max-width: 992px){
  .main-banner .container {z-index: 11; position: relative; mix-blend-mode: darken;}
}

.main-banner #videoContent {
    position: absolute;
    top: 0; right: 0;
    bottom: 0;
    display: block;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    background: #fff;
    filter: grayscale(1);
    mix-blend-mode: darken;
    z-index: 10;
}
.main-banner #videoContent::after {
    content: "";
    position: absolute;
    top: 0; right: 0;
    bottom: 0;
    display: block;
    width: 100%;
    opacity: 1;
    background: -webkit-linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,.4) 100%);
    background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,.4) 100%);
}

@media(min-width: 992px){
    .banner-content h1  {
        font-size: 3vw;
    }
    .main-banner #videoContent::after {
        background: -webkit-linear-gradient(90deg, rgba(255,255,255,.9) 0%, rgba(255,255,255,0) 100%);
        background: linear-gradient(90deg, rgba(255,255,255,.9) 0%, rgba(255,255,255,0) 100%);
    }
    .main-banner:not(.ismobile) #videoContent {
        width: 60%;
        max-width: 60%;
    }
    .main-banner-prev {
      min-height: 500px; height: calc(60vw * 720 / 1280);
    }
    .main-banner .carousel {width: 70%}
    .main-banner,
    .main-banner .carousel-item, .banner-content  {min-height: 500px;}
}
@media(min-width: 1400px){
    .banner-content h1 {font-size: 3rem;}
}
#videoBG, #imgBG {
  width: 100%; min-width: 890px; right: 0; top: 50%; position: absolute; transform: translate(0,-50%); -webkit-transform: translate(0,-50%);
}

.main-banner.ismobile #videoContent {
  height: calc(100vw / 16 * 9);
  max-height: 400px;
}

</style>
